import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { Toast } from "react-bootstrap";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";

type User = {
  id?: number;
  title?: string;
  date?: string; // format: "YYYY-MM-DD"
  start_time?: string; // format: "HH:MM:SS"
  end_time?: string;   // format: "HH:MM:SS"

  state?: number;
  state_name?: string;

  zone?: number;
  zone_name?: string;

  branch?: number;
  branch_name?: string;

  audience_type?: number;
  audience_type_name?: string;

  program_type?: number;
  program_type_name?: string;

  seminar_status?: number;
  seminar_status_name?: string;

  response?: number;
  response_name?: string;

  remarks?: string;
  members_attended_count?: number;
  photo?: string | null;

  seminar_conducted_by?: number;
  seminar_conducted_by_name?: string;

  classes?: Array<number>;
  class_names?: string;

  sections?: Array<number>;
  section_names?: string;

  orientations?: Array<number>;
  orientation_names?: string;

  is_active?: boolean;
};

type ErrorMessage = {
  start_time?: any;
  end_time?: any;
  members_attended_count?: string[];
  title?: string[];
  date?: string[];
  remarks?: string[];
  username?: string[];
  password?: string[];
  is_active?: string[];
  first_name?: string[];
  last_name?: string[]
  email?: string[]
};

interface Group {
  id: number;
  name: string;
}
type Branch = {
  branch_id: number;
  name: string;
  label: string;
};

type AudienceType = {
  id: number;
  name: string;
};

type SeminarStatus = {
  id: number;
  name: string;
};

type ResponseType = {
  id: number;
  name: string;
};

type Class = {
  id: number;
  name: string;
};

type Orientation = {
  id: number;
  name: string;
};

type Section = {
  id: number;
  name: string;
};




type Permission = { id: number; name: string };

const AddSeminors = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { webApi, userPermissions } = useUserPermissions();
  const [errorMessage, setErrorMessage] = useState<ErrorMessage>({});
  const [groupsDropdown, setGroupsDropdown] = useState<Group[]>([]);
  const [chosenGroups, setChosenGroups] = useState<Group[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [branchesData, setBranchesData] = useState<Branch[]>([]);
  const [audienceTypesData, setAudienceTypesData] = useState<AudienceType[]>([]);
  const [seminarStatusesData, setSeminarStatusesData] = useState<SeminarStatus[]>([]);
  const [responsesData, setResponsesData] = useState<ResponseType[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<Option | null>(null);
  const [selectedAudienceType, setSelectedAudienceType] = useState<Option | null>(null);
  const [selectedSeminarStatus, setSelectedSeminarStatus] = useState<Option | null>(null);
  const [selectedResponse, setSelectedResponse] = useState<Option | null>(null);
  const [classesDropdown, setClassesDropdown] = useState<Class[]>([]);
  const [orientationsDropdown, setOrientationsDropdown] = useState<Orientation[]>([]);
  const [sectionsDropdown, setSectionsDropdown] = useState<Section[]>([]);
  const [chosenClasses, setChosenClasses] = useState<Class[]>([]);
  const [chosenOrientations, setChosenOrientations] = useState<Orientation[]>([]);
  const [chosenSections, setChosenSections] = useState<Section[]>([]);

  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if ((showSolidDangerToast || showSolidSuccessToast) === true) {
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  }, [toastMessage])
  const [isLoading, setIsLoading] = useState(false);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [newUser, setNewUser] = useState<User>({
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async () => {
    const response = await fetch(
      `${webApi}/user/get_groups_dropdown/`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchDefaultPermissions = async () => {
    const response = await fetch(
      `${webApi}/user/get_permissions_dropdown/group_id/0/`,
      options
    );
    return await response.json();
  };

  const fetchBranches = async () => {
    const response = await fetch(`${webApi}/branches/wizklub_branches_dropdown/`, options)
    const data = await response.json();
    setBranchesData(data)
  }
  const fetchAudienceTypes = async () => {
    const response = await fetch(`${webApi}/seminars/audience_type_dropdown/`, options);
    const data = await response.json();
    setAudienceTypesData(data);
  };

  const fetchSeminarStatuses = async () => {
    const response = await fetch(`${webApi}/seminars/seminar_status_dropdown/`, options);
    const data = await response.json();
    setSeminarStatusesData(data);
  };

  const fetchResponses = async () => {
    const response = await fetch(`${webApi}/seminars/seminar_response_dropdown/`, options);
    const data = await response.json();
    setResponsesData(data);
  };

  const fetchClasses = async () => {
    const response = await fetch(`${webApi}/branches/wizklub_class_names_dropdown/`, options);
    const data = await response.json();
    const formattedClasses = data.map((item: any) => ({
      id: item.class_name_id,
      name: item.name,
    }));
    setClassesDropdown(formattedClasses);
  };
  const fetchOrientations = async () => {
    const response = await fetch(`${webApi}/branches/branch_wise_orientations/?branch_id=${selectedBranch?.value}`, options);
    const data = await response.json();
    const formattedOrientations = data.map((item: any) => ({
      id: item.orientation_id,
      name: item.name,
    }));

    setOrientationsDropdown(formattedOrientations);
  };
  const fetchSections = async () => {
    const classIds = chosenClasses.map((c) => c.id).join(",");
    const orientationIds = chosenOrientations.map((o) => o.id).join(",");

    const response = await fetch(
      `${webApi}/branches/section_dropdown_based_on_branch_orientation_class/?branch_id=${selectedBranch?.value}&class_id=${classIds}&orientation_id=${orientationIds}`,
      options
    );

    const data = await response.json();

    const formattedSections = data.map((item: any) => ({
      id: item.section_id,
      name: item.label,
    }));

    setSectionsDropdown(formattedSections);
    const filteredChosenSections = chosenSections.filter((sec: { id: any }) =>
      data.some((item: any) => item.section_id === sec.id)
    );
    setChosenSections(filteredChosenSections);
  };



  const fetchData = async () => {
    try {
      const [groupsData, permissionsData] = await Promise.all([
        fetchGroupsData(),
        fetchDefaultPermissions(),
      ]);
      setGroupsDropdown(groupsData.results);
      setPermissions(permissionsData.results);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (!checkPermission("add_seminarorientation", "seminarorientation")) {
      navigate(routes.crmLandingPage);
    } else {
      // fetchData();
      fetchBranches();
      fetchAudienceTypes();
      fetchSeminarStatuses();
      fetchResponses();
      fetchClasses();

    }
  }, [userPermissions]);

  useEffect(() => {

    if (
      selectedBranch &&
      Array.isArray(chosenClasses) && chosenClasses.length > 0 &&
      Array.isArray(chosenOrientations) && chosenOrientations.length > 0
    ) {
      fetchSections();
    }

  }, [selectedBranch, chosenClasses, chosenOrientations])

  useEffect(() => {
    if (selectedBranch) {
      fetchOrientations();
    }
  }, [selectedBranch])


  const updateData = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newUser),
    };
    const url = `${webApi}/seminars/seminar_orientation/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      setErrorMessage(errorData);
      // setToastMessage(errorData.username || errorData.password || errorData.is_active);
      // if (toastMessage !== "") {
      //   setShowSolidDangerToast(true);
      // }
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.seminors);
    } catch (error) { }
    finally { setIsLoading(false); }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewUser({ ...newUser, [name]: value || null });
  };

  const handleInputChange1 = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setNewUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewUser({ ...newUser, [name]: value === "true" });
  };

  const handlePermissionsChange = async (
    selected: Permission[] | Group[],
    type: "classes" | "orientations" | "sections"
  ) => {
    if (type === "classes") {
      setChosenClasses(selected as Class[]);
      setNewUser({
        ...newUser,
        classes: (selected as Class[]).map(
          (permission) => permission.id
        ),
      });
      if (!selected || selected.length === 0) {
        setSectionsDropdown([]); // Add this line
        setChosenSections([]);
      }
    } else if (type === "orientations") {
      setChosenOrientations(selected as Orientation[]);
      setNewUser({
        ...newUser,
        orientations: (selected as Orientation[]).map((group) => group.id),
      });
      if (!selected || selected.length === 0) {
        setSectionsDropdown([]); // Add this line
      }
    }
    else if (type === "sections") {
      setChosenSections(selected as Section[]);
      setNewUser({
        ...newUser,
        sections: (selected as Section[]).map((group) => group.id),
      });
    }
  };

  const handleBranchChange = (selected: Option | null) => {
    const branch = branchesData.find(
      (b) => b.branch_id === parseInt(selected?.value || "")
    );
    setSelectedBranch(
      branch
        ? { value: branch.branch_id.toString(), label: branch.name }
        : null
    );
    setNewUser({
      ...newUser,
      branch: branch?.branch_id,
    });
    setChosenOrientations([]);
    setChosenSections([]);
    setSectionsDropdown([]);
    setChosenClasses([]);
  };

  const handleAudienceTypeChange = (selected: Option | null) => {
    const audience = audienceTypesData.find(
      (a) => a.id === parseInt(selected?.value || "")
    );
    setSelectedAudienceType(
      audience
        ? { value: audience.id.toString(), label: audience.name }
        : null
    );
    setNewUser({
      ...newUser,
      audience_type: audience?.id,
    });
    setChosenClasses([]);
    setChosenOrientations([]);
    setChosenSections([]);
  };

  const handleSeminarStatusChange = (selected: Option | null) => {
    const status = seminarStatusesData.find(
      (s) => s.id === parseInt(selected?.value || "")
    );
    setSelectedSeminarStatus(
      status
        ? { value: status.id.toString(), label: status.name }
        : null
    );
    setNewUser({
      ...newUser,
      seminar_status: status?.id,
    });
  };

  const handleResponseChange = (selected: Option | null) => {
    const response = responsesData.find(
      (r) => r.id === parseInt(selected?.value || "")
    );
    setSelectedResponse(
      response
        ? { value: response.id.toString(), label: response.name }
        : null
    );
    setNewUser({
      ...newUser,
      response: response?.id,
    });
  };





  const branchOptions = branchesData.map((b) => ({
    value: b.branch_id.toString(),
    label: b.name,
  }));

  const audienceTypeOptions = audienceTypesData.map((a) => ({
    value: a.id.toString(),
    label: a.name,
  }));
  const seminarStatusOptions = seminarStatusesData.map((s) => ({
    value: s.id.toString(),
    label: s.name,
  }));
  const responseOptions = responsesData.map((r) => ({
    value: r.id.toString(),
    label: r.name,
  }));


  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Orientation</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.crmLandingPage}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.seminors}>Orientations</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Orientation</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "15px",
                }}
              >
                <div className="card-body">
                  <form
                    onSubmit={handleSubmit}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") handleSubmit(e);
                    }}
                  >
                    <div className="modal-body light-violet-bg">
                      <div className="row">
                        {/* Title */}
                        <div className="col-12 col-md-6 mb-3">
                          <label className="form-label">Title <span style={{ color: "red" }}>*</span></label>
                          <input
                            type="text"
                            className={`form-control ${errorMessage.title ? "is-invalid" : ""}`}
                            onChange={handleInputChange}
                            name="title"
                            placeholder="Title"
                            value={newUser.title || ""}
                            required
                          />
                          {errorMessage.title && <div className="invalid-feedback">{errorMessage.title[0]}</div>}
                        </div>

                        {/* Date */}
                        <div className="col-12 col-md-6 mb-3">
                          <label className="form-label">Date <span style={{ color: "red" }}>*</span></label>
                          <input
                            type="date"
                            className={`form-control ${errorMessage.date ? "is-invalid" : ""}`}
                            onChange={handleInputChange}
                            name="date"
                            value={newUser.date || ""}
                            required
                          />
                          {errorMessage.date && <div className="invalid-feedback">{errorMessage.date[0]}</div>}
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                          <label className="form-label">
                            Start Time <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            className={`form-control ${errorMessage.start_time ? "is-invalid" : ""}`}
                            onChange={handleInputChange}
                            name="start_time"
                            value={newUser.start_time || ""}
                            required
                          />
                          {errorMessage.start_time && (
                            <div className="invalid-feedback">{errorMessage.start_time[0]}</div>
                          )}
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                          <label className="form-label">
                            End Time <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            className={`form-control ${errorMessage.end_time ? "is-invalid" : ""}`}
                            onChange={handleInputChange}
                            name="end_time"
                            value={newUser.end_time || ""}
                            min={newUser.start_time || undefined} // Prevent selecting earlier than start time
                            disabled={!newUser.start_time}         // Disable if no start time is selected
                            required
                          />
                          {errorMessage.end_time && (
                            <div className="invalid-feedback">{errorMessage.end_time[0]}</div>
                          )}
                        </div>


                        {/* Branch */}
                        <div className="col-12 col-md-6 mb-3">
                          <label className="form-label">Branch</label>
                          <CommonSelect
                            className="select"
                            options={branchOptions}
                            onChange={handleBranchChange}
                            value={selectedBranch}
                            isRequired
                          />
                        </div>

                        {/* Audience Type */}
                        <div className="col-12 col-md-6 mb-3">
                          <label className="form-label">Audience Type</label>
                          <CommonSelect
                            className="select"
                            options={audienceTypeOptions}
                            onChange={handleAudienceTypeChange}
                            value={selectedAudienceType}
                            isRequired
                          />
                        </div>

                        {/* Seminar Status */}
                        <div className="col-12 col-md-6 mb-3">
                          <label className="form-label">Seminar Status</label>
                          <CommonSelect
                            className="select"
                            options={seminarStatusOptions}
                            onChange={handleSeminarStatusChange}
                            value={selectedSeminarStatus}
                            isRequired
                          />
                        </div>

                        {/* Response */}
                        {selectedSeminarStatus?.label === "Completed" && (
                          <>
                            {/* Response - Only visible when status is "Completed" */}
                            <div className="col-12 col-md-6 mb-3">
                              <label className="form-label">Response</label>
                              <CommonSelect
                                className="select"
                                options={responseOptions}
                                onChange={handleResponseChange}
                                value={selectedResponse}
                                isRequired
                              />
                            </div>

                            {/* Count - Only visible when status is "Completed" */}
                            <div className="col-12 col-md-6 mb-3">
                              <label className="form-label">
                                Count <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control ${errorMessage.members_attended_count ? "is-invalid" : ""}`}
                                onChange={handleInputChange}
                                name="members_attended_count"
                                value={newUser.members_attended_count || ""}
                                required
                              />
                              {errorMessage.members_attended_count && (
                                <div className="invalid-feedback">{errorMessage.members_attended_count[0]}</div>
                              )}
                            </div>
                          </>
                        )}
                        {(selectedAudienceType?.label === "Parents" || selectedAudienceType?.label === "Students") && (
                          <>
                            <div className="col-12 col-lg-12 mb-4">
                              <label className="form-label">Classes</label>
                              <DualListBox
                                options={classesDropdown}
                                selected={chosenClasses}
                                onChange={(selected) => handlePermissionsChange(selected, "classes")}
                              />
                            </div>

                            <div className="col-12 col-lg-12 mb-4">
                              <label className="form-label">Orientations</label>
                              <DualListBox
                                options={orientationsDropdown}
                                selected={chosenOrientations}
                                onChange={(selected) => handlePermissionsChange(selected, "orientations")}
                              />
                            </div>

                            <div className="col-12 col-lg-12 mb-4">
                              <label className="form-label">Sections</label>
                              <DualListBox
                                options={sectionsDropdown}
                                selected={chosenSections}
                                onChange={(selected) => handlePermissionsChange(selected, "sections")}
                              />
                            </div>
                          </>
                        )}
                        {/* Remarks */}
                        <div className="col-12 mb-3">
                          <label className="form-label">Remarks</label>
                          <textarea
                            className={`form-control ${errorMessage.remarks ? "is-invalid" : ""}`}
                            onChange={handleInputChange1}
                            name="remarks"
                            placeholder="Remarks"
                            value={newUser.remarks || ""}
                            rows={3}
                          />
                          {errorMessage.remarks && (
                            <div className="invalid-feedback">{errorMessage.remarks[0]}</div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Footer Buttons */}
                    <div className="modal-footer d-flex justify-content-between flex-wrap">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.seminors}
                        style={{ backgroundColor: "lightcoral", color: "white" }}
                      >
                        Cancel
                      </Link>
                      <button className="btn btn-primary" type="submit" disabled={isLoading}>
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default AddSeminors;
